import { useCheckUserPreOrder } from '@/hooks/usePageMountEffect';

export default function UserPreOrder() {
  // useCheckUserPreOrder();
  return null;
}
